import styled from "styled-components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppButton from "../../../../AppComponents/AppButton";
import { AppConfig } from "../../../../Config/app-config";
import { ChatbotConsoleService } from "../../../../Services/Apis/ChatbotConsoleService";
import { useCurrentBot } from "../../../../Store/Slices/DashboardSlices";
const BOT_ID_KEY = 'currentBotId'
interface Props {
  handleConnectSheet: any;
  handleDisconnectButton: any;
  googleSheetLink: any;
}

const GoogleSheetsConfig :React.FC<Props> =  ({
  handleConnectSheet,
  handleDisconnectButton,
  googleSheetLink
}) => {

  return (
    <GooglePageWrap>
      <div className="pageTopbar">
        <div className="accountInfo">
          <AppButton variant="danger" onClick={() => handleDisconnectButton()}>
            Disconnect
          </AppButton>
        </div>
      </div>
      <div className="pageTopbar">
        {/* <AppIcon title={"ri-arrow-left-line"} size="26px" color="#282828" /> */}
      </div>
      <div className="ctaBox">
        <img
          className="companyLogo"
          src="https://upload.wikimedia.org/wikipedia/commons/3/30/Google_Sheets_logo_%282014-2020%29.svg"
        />
        <div className="linkCSS">
          <p>{googleSheetLink.createdlinkID['link']}</p>
        </div>
        <p className="ctaTitle">
            <AppButton startIcon="ri-links-line" onClick={()=>handleConnectSheet()}>Connect to Sheet</AppButton>
        </p>
      </div>
    </GooglePageWrap>
  );
};

export default GoogleSheetsConfig;

const GooglePageWrap = styled.div`
  && {
    height: 100%;
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: column;

    .pageTopbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 48px;
      width: 100%;
    }

    .ctaBox {
      display: flex;
      height: 40%;
      flex-direction: column;
      gap: 1.6rem;
      padding: 1rem;
      justify-content: center;
      align-items: center;
    }

    .companyLogo {
      width: 96px;
      height: 96px;
      border-radius: 50%;
      object-fit: contain;
      background-color: #f5f6f8;
      padding: 0.2rem;
    }

    .buttonBox {
      width: 100% !important;
      display: flex;
      justify-content: center;
    }

    .ctaTitle {
      font-size: 1.2rem;
    }

    .linkCSS {
      padding: 1rem;
      background: gainsboro;
    }
  }
`;
